var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"print-screen",attrs:{"title":"print screen"},on:{"click":_vm.printScreen}},[_c('picture',[_c('img',{attrs:{"src":require("@/assets/icons/printFriendly.svg"),"alt":"logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }